<mat-toolbar class="z5-toolbar" color="primary">
	<a routerLink="/" class="app-logo"></a>
	<span class="d-none d-md-block">
		<ng-container *ngFor="let item of mainMenuItems">
			<a
				*ngIf="!externalLink(item.path); else externalLinkTemplate"
				mat-button
				[routerLink]="[item.path]"
				class="main-menu-item {{item.class}}"
				routerLinkActive="active"
				title="{{item.name}}"
			>
				<span>{{ item.name }}</span>
				<app-system-alert-badge [ids]="item.alertIds"></app-system-alert-badge>
			</a>

			<ng-template #externalLinkTemplate>
				<a
					mat-button
					class="main-menu-item {{item.class}}"
					[href]="item.path"
					target="_blank"
					title="{{item.name}}"
				>
					<span>{{ item.name }}</span>
					<app-system-alert-badge [ids]="item.alertIds"></app-system-alert-badge>
				</a>
			</ng-template>
		</ng-container>
	</span>
	<span class="fill-remaining-space"></span>
	<span>
		<button mat-button class="top-drop-menu-btn" [matMenuTriggerFor]="topMenu" *ngIf="myAccountItem">
			<span class="material-icons user-avatar d-none d-md-block">account_circle</span>
			<span class="account-user d-none d-md-block">{{ accountUserFullname }}</span>
			<span class="material-icons user-avatar d-sm-block d-md-none hamburger-icon">menu</span>
			<app-system-alert-badge [ids]="myAccountItem.alertIds"></app-system-alert-badge>
		</button>
		<mat-menu #topMenu="matMenu" xPosition="before">
			<div class="top-right-drop-menu">
				<div class="account-user d-sm-block d-md-none">
					<div class="user-avatar"><span class="material-icons">account_circle</span></div>
					<div class="username">{{ accountUserFullname }}</div>
				</div>
				<a
					mat-menu-item
					[routerLink]="myAccountItem.path"
					routerLinkActive="active"
					class="top-right-drop-menu--link"
				>
					<span i18n="My account|menu link that points to user's account page">My account</span>
					<app-system-alert-badge [ids]="myAccountItem.alertIds"></app-system-alert-badge>
				</a>
				<mat-divider></mat-divider>

				<!-- Main menu items -->
				<span *ngFor="let item of mainMenuItems" class="d-sm-block d-md-none">
					<a
						*ngIf="!externalLink(item.path); else externalLinkTemplate"
						mat-menu-item
						[routerLink]="[item.path]"
						class="top-right-drop-menu--link {{item.class}}"
						routerLinkActive="active"
						title="{{item.name}}"
					>
						<span>{{ item.name }}</span>
						<app-system-alert-badge [ids]="item.alertIds"></app-system-alert-badge>
					</a>

					<ng-template #externalLinkTemplate>
						<a
							mat-menu-item
							class="top-right-drop-menu--link {{item.class}}"
							[href]="item.path"
							target="_blank"
							title="{{item.name}}"
						>
							<span>{{ item.name }}</span>
							<app-system-alert-badge [ids]="item.alertIds"></app-system-alert-badge>
						</a>
					</ng-template>
				</span>
				<!-- END Main menu items -->
				<button mat-menu-item (click)="logout()">
					<span i18n="logout menu item|menu item to log out of the website">Log out</span>
				</button>
			</div>
		</mat-menu>
	</span>
</mat-toolbar>
<div class="main-contents" [ngClass]="hasAlerts ? 'has-alerts' : ''">
	<router-outlet></router-outlet>
</div>
<div class="row mx-0 align-items-center z5-footer">
	<div class="col">
		<a href="https://www.specialized.com/" rel="noopener" target="_blank">
			&copy; Copyright {{ currentDate | date:'yyyy'}} Specialized Bicycle Components, Inc. All Rights Reserved.
		</a>
	</div>
	<div class="col-xs-auto pt-1 pr-2 build-version">
		<app-build-version></app-build-version>
	</div>
</div>
